@import "../../global/gx-ide-common.scss";
@import "../../global/gx-ide-mixins.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: max-content 1fr;
}
.section {
  display: contents;
}

.header {
  /*Top*/
  &__top {
    grid-template-columns: max-content 1fr max-content;
  }
  /*Bottom*/
  &__bottom {
    display: grid;
    grid-template-rows: 1fr;
    transition: var(--timing-fast) grid-template-rows;
    &--hidden {
      grid-template-rows: 0fr;
    }

    .outer-wrapper {
      overflow: hidden;
    }

    .inner-wrapper {
      padding-top: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      &__left {
        display: flex;
        align-items: center;
        gap: var(--spacing-gap-xl);
      }
    }
  }
}

.main {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.section__referenced-by,
.section__references-to {
  display: grid;
  grid-template-rows: max-content 1fr;
}
.dialog-header__referenced-by,
.dialog-header__references-to {
  padding-block-start: 16px;
}
.main__referenced-by,
.main__references-to {
  grid-auto-rows: max-content;
  overflow: auto;
}
.main__referenced-by {
  border-inline-end: var(--section-common-border);
}

.text-align-center {
  text-align: center;
}
